
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class ProjectService {
    constructor(private http: Http) { }

    getProjectInfo(customerid: string) {
        let url = `${environment.api.serviceurl}` + "GetAdditionalFields?customerid=" + customerid;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let projectInfo = response.json();
                let t = projectInfo.GetAdditionalFieldsResult;
                let p = ('(' + t + ')');
                let s = eval(p);

                return s;
            }));
    }

    getprojectInfo(customerId: string, country: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getAdditionalFields";
        let orderData = { "customerid": customerId, "stringData": country };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    private extractData(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = JSON.parse(body.orderid);
            return jsonbody || {};
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}